import type { TicketWaiverType } from '@/lib/api/tickets.js';

type WaiverSignaturePreviewProps = {
  ticketId: string;
  waiverType: TicketWaiverType;
  signatureUrl: string;
  downloadName: string;
};

function downloadSignature(dataUrl: string, filename: string) {
  const anchor = document.createElement('a');
  anchor.href = dataUrl;
  anchor.download = filename.endsWith('.png') ? filename : `${filename}.png`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function WaiverSignaturePreview({
  ticketId,
  waiverType,
  signatureUrl,
  downloadName,
}: WaiverSignaturePreviewProps) {
  const recordPath = `/tickets/${ticketId}/waiver/${waiverType}/record`;

  return (
    <div className="mt-3 space-y-2">
      <div className="rounded-xl border border-slate-200 bg-white p-3">
        <img
          src={signatureUrl}
          alt="Customer signature"
          className="mx-auto max-h-32 w-full max-w-md object-contain"
        />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50"
          onClick={() => window.open(recordPath, '_blank', 'noopener,noreferrer')}
        >
          View signed record
        </button>
        <button
          type="button"
          className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50"
          onClick={() => downloadSignature(signatureUrl, downloadName)}
        >
          Download signature PNG
        </button>
      </div>
    </div>
  );
}
